import React from "react";
import { Link } from "react-router-dom";
import Container from "../../components/Container";
import CustomInput from "../../components/CustomInput";
import logo from "../../assets/images/logo.png";
import { IoArrowForwardOutline } from "react-icons/io5";
import ComboBox from "../../components/ComboBox";
import countryListArray from "../../assets/data/countryList.json";
import Button from "../../components/Button";

const SecondRegisterStep = () => {
  const genders = [
    {
      id: 0,
      value: "male",
      label: "Male",
    },
    {
      id: 1,
      value: "female",
      label: "Female",
    },
    {
      id: 2,
      value: "other",
      label: "Other",
    },
  ];

  const countryList = countryListArray.map((country, index) => ({
    id: index,
    value: country.toLowerCase(),
    label: country,
  }));
  return (
    <section>
      <Container maxWidth={"max-w-3xl"}>
        <div className="header my-6">
          <div className="flex justify-between items-center">
            <div className="logo w-28">
              <Link to={"/everyone"}>
                <img src={logo} alt="" />
              </Link>
            </div>
            <div className="sign-in">
              <Link to={"/log-in"} className="flex items-center gap-3 p-3">
                <span>Sign In</span>
                <span>
                  <IoArrowForwardOutline />
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className="bg-white xs:p-4 md:p-10 border rounded-lg">
          <div className="text-lg font-semibold mb-6">
            <p className="">
              Hi, Abdulateef! We need some information so we can improve your
              experience
            </p>
          </div>
          <div className="form my-3">
            <form action="flex flex-auto">
              <div className="gender w-full mb-4 flex flex-col shrink-0">
                <label htmlFor="country" className="pb-1">
                  Gender
                </label>
                <ComboBox
                  options={genders}
                  selectedClassNames={{
                    border: "border-2",
                    rounded: "rounded-md",
                    padding: "p-2",
                  }}
                  dropDownClassNames={{
                    minWidth: "min-w-full",
                  }}
                />
              </div>
              <div className="country w-full mb-4 flex flex-col">
                <label htmlFor="country" className="pb-1">
                  Country
                </label>
                <ComboBox
                  options={countryList}
                  selectedClassNames={{
                    border: "border-2",
                    rounded: "rounded-md",
                  }}
                  dropDownClassNames={{
                    minWidth: "min-w-full",
                  }}
                  isSearchable
                />
              </div>
              <div className="DOB flex-auto mb-4 flex flex-col">
                <CustomInput
                  label={"Date of Birth"}
                  name="DOB"
                  type="date"
                  className="w-full mb-4"
                />
              </div>
              <div className="phone-number flex-auto mb-4 flex flex-col">
                <CustomInput
                  label={"Phone Number"}
                  name="phoneNumber"
                  type="tel"
                  placeholder={"Enter your Phone Number"}
                  className="w-full mb-4"
                />
              </div>
              <div className="continue flex-auto mb-4 flex flex-col">
                <Link to="/everyone/">
                  <Button width={"w-full"}>Continue</Button>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default SecondRegisterStep;
